import { FETCH_PROJECT_DATA_CONNECTORS } from '../actions/types';

const initialState = null;

function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROJECT_DATA_CONNECTORS:
      return action.payload;
    default:
      return state;
  }
}
export default reducer;
